/**
 * Qué rutas se sirven sin sesión — y cuál de ellas es la landing.
 *
 * `App.tsx` decidía esto con una expresión suelta, y `WorkspaceContext` ahora
 * necesita la misma respuesta: en la landing no se resuelve el taller ni se
 * carga la capa de datos. Dos copias de la lista es la receta para que una
 * ruta nueva entre en una y no en la otra.
 *
 * La landing va aparte porque NO es lo mismo que «pública»: la propuesta
 * pública (`/public/proposal/:id`) vive dentro del armazón de la app y, para
 * quien tiene sesión, pasa por las mismas puertas que el resto (ajustes,
 * asistente de alta). La landing es la única ruta que se pinta ANTES de todas
 * ellas, así que es la única donde se puede dejar el taller sin resolver.
 */
export const esLanding = (pathname: string): boolean => pathname === '/';

export const esRutaPublica = (pathname: string): boolean =>
    esLanding(pathname) || pathname.startsWith('/public/proposal/');
